(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultHomeController', DefaultHomeController)

	/** @ngInject */
	function DefaultHomeController() {
		const vm = this;

	}
}());